module.exports = "/_next/static/images/BadgeEnterprise@2x-51bb3b8a11c3092b36bd8db09a47522e.png";